import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IHeadingPayload {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  variant?: string;
  content?: string;
  heading_tag?: string;
  font_family?: string;
  desktop_font_size?: number | string;
  mobile_font_size?: number | string;
  font_weight?: number | string;
  line_height?: string;
  text_color?: string;
  background_color?: string;
  word_break?: boolean;
  status?: boolean;
}

export async function createHeading(payload: Partial<IHeadingPayload>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.HEADING.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateHeading(
  id: number,
  payload: Partial<IHeadingPayload>
) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.HEADING.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
